module.exports = __webpack_public_path__ + "static/media/clinica.0e3c8c81.svg";